export default __webpack_public_path__ + "static/media/breathe0.8513288b.gif";